import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AuthenticatedComponent} from './authenticated.component';
import {AuthenticatedRoutingModule} from './authenticated-routing.module';
import {LayoutModule} from '../../layouts/layout.module';
import {FormsModule} from "@angular/forms";

@NgModule({
    imports: [
        CommonModule,
        LayoutModule,
        AuthenticatedRoutingModule,
        FormsModule
    ],
    declarations: [AuthenticatedComponent]
})
export class AuthenticatedModule {
}
